import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import moment from 'moment';
import api from './api';
import './plugins/antd';
import './plugins/components';
import store from './store/'
import qs from 'qs';
import regular from './plugins/regular'
import utils from '@/plugins/utils'
import Filter from '@/plugins/filter';
import EventBus from './plugins/eventBus'
import Md5 from 'js-md5';
import https from '../public/settings'

Vue.prototype.$eventBus = EventBus;
Vue.prototype.$moment = moment;
Vue.prototype.$qs = qs;
Vue.prototype.$api = api;
Vue.prototype.$regular = regular;
Vue.prototype.$utils = utils;
Vue.prototype.$domain = baseConfig.vue_base_url;
Vue.prototype.$md5 = Md5;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 
